import React, { useRef } from 'react';
import useEventListener from '@/hooks/useEvenListener';
import { toSnakeCase } from '@/utils/toSnakeCase';
import TooltipStyled from './Tooltip.styled';
import { useWindowIsMobile } from '@/hooks/useWindowIsMobile';

interface TooltipProps {
  className?: string;
  text: string;
}

const Tooltip = ({ className, text }: TooltipProps) => {
  const elTooltip = useRef<HTMLDivElement>(null);
  const isMobile = useWindowIsMobile();

  const onKeydown = (evt: KeyboardEvent) => {
    if (evt.key === 'Escape' || isMobile) {
      elTooltip.current?.classList.add('hidden');
    } else if (!isMobile) {
      elTooltip.current?.classList.remove('hidden');
    }
  };

  useEventListener('keydown', onKeydown);

  if (!text) return null;

  return (
    <TooltipStyled
      ref={elTooltip}
      role="tooltip"
      id={toSnakeCase(text) || ''}
      className={className}
    >
      <div className="tooltip-bg"></div>
      <div className="tooltip-text">{text}</div>
    </TooltipStyled>
  );
};

export default Tooltip;
